/**
 * React component for rendering the main carousel section on Home page.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.data - Data object containing information for the carousel section.
 * @returns {JSX.Element} - The rendered React component for the main carousel section.
 */

import React from "react";
import Carousel from "./Carousel";

const CarouselMain = ({ data }) => {
  return (
    <section className={`gridLinesBgLayout mt-[80px] lg:mt-[160px]`}>
      <div className={`gridCarouselSectionPadding carouselSectionPadding`}>
        <Carousel data={data} />
      </div>
    </section>
  );
};

export default CarouselMain;
